import React from "react";
import { useDispatch } from "react-redux";
import { LeftPanel, MainContainer, RightPanel } from "../login/LoginLayout";
import { StackPanelLogo } from "../login/StackCarePanelLogo";
import { useTranslation } from "react-i18next";
import {
  Typography,
  makeStyles,
  createStyles,
  Theme,
  Button,
  Box,
} from "@material-ui/core";
import { Views } from "../../helpers/constants";
import { useHistory } from "react-router-dom";
import AccountManagementHeader from "../login/AccountManagementHeader";
import { logout } from "../login/loginSlice";
import LeftPanelFooter from "../login/LeftPanelFooter";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainText: {
      color: theme.palette.dark.main,
      fontWeight: "bold",
      fontSize: "1.8rem",
      width: "100%",
      marginTop: "90px",
    },
    subText: {
      color: theme.palette.dark.main,
      fontSize: "1.2rem",
      marginTop: "50px",
      width: "75%",
    },
    buttons: {
      color: theme.palette.paused.main,
      fontWeight: "bold",
      padding: "0px 0px",
      "&:hover": {
        background: "transparent",
      },
    },
    buttonBox: {
      marginTop: "50px",
    },
    signOut: {
      color: theme.palette.paused.main,
      width: "65px",
      padding: "0px 0px",
      "&:hover": {
        background: "transparent",
      },
    },
  })
);

export default function AccessExpired() {
  /* ---- Hooks ---- */
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  /* ---- Utils ---- */
  const handleBackToLogin = () => {
    dispatch(logout());
    history.push(Views.LOGIN);
  };

  return (
    <MainContainer>
      <LeftPanel>
        <StackPanelLogo />
        <AccountManagementHeader />
        <Box>
          <Button onClick={handleBackToLogin} className={classes.signOut}>
            {t("sign_out")}
          </Button>
        </Box>
        <LeftPanelFooter />
      </LeftPanel>
      <RightPanel>
        <Typography className={classes.mainText}>
          {t("access_expired")}
        </Typography>
        <Typography className={classes.subText}>
          {t("access_expired_body")}
        </Typography>
        <Box className={classes.buttonBox}>
          <Button onClick={handleBackToLogin} className={classes.buttons}>
            {t("sign_out")}
          </Button>
        </Box>
      </RightPanel>
    </MainContainer>
  );
}
